<template>
  <div class="more_wrapper"
       @click.stop="handleClsoe">
    <div class="container scroll_wrapper"
         @click.stop="stopPrev">
      <div class="scroll_content"
           style="height: 100%;">
        <van-row type="flex"
                 align="center">
          <van-col span="10">
            <van-image width="100%"
                       height="22"
                       fit="cover"
                       src="/images/line_left@2x.png" />
          </van-col>
          <van-col span="4">
            <div class="title">活动</div>
          </van-col>
          <van-col span="10">
            <van-image width="100%"
                       height="22"
                       fit="cover"
                       src="/images/line_right@2x.png" />
          </van-col>
        </van-row>
        <van-row>
          <van-col :span="rowspan"
                   v-for="(item, index) in activity"
                   :key="index"
                   class="click_able"
                   style="margin-top: 20px;">
            <div class="list"
                 @click="navigateTo(item.url)">
              <van-image width="100"
                         height="100"
                         fit="cover"
                         lazy-load
                         :src="item.icon">
                <template v-slot:loading>
                  <van-loading type="spinner"
                               size="20" />
                </template>
              </van-image>
              <div class="text">{{ item.title }}</div>
            </div>
          </van-col>
        </van-row>
        <van-row type="flex"
                 align="center"
                 style="margin-top: 40px;">
          <van-col span="10">
            <van-image width="100%"
                       height="22"
                       fit="cover"
                       src="/images/line_left@2x.png" />
          </van-col>
          <van-col span="4">
            <div class="title">资料</div>
          </van-col>
          <van-col span="10">
            <van-image width="100%"
                       height="22"
                       fit="cover"
                       src="/images/line_right@2x.png" />
          </van-col>
        </van-row>
        <van-row>
          <van-col :span="rowspan"
                   v-for="(item, index) in resource"
                   :key="index"
                   class="click_able"
                   style="margin-top: 20px;">
            <div class="list"
                 @click="navigateTo(item.url)">
              <van-image width="100"
                         height="100"
                         fit="cover"
                         :src="item.icon"
                         lazy-load>
                <template v-slot:loading>
                  <van-loading type="spinner"
                               size="20" />
                </template>
              </van-image>
              <div class="text">{{ item.title }}</div>
            </div>
          </van-col>
        </van-row>
        <van-row style="
            margin-top: 40px;
            height: 1px;
            background: rgba(255, 255, 255, 0.2);
          ">
        </van-row>
        <van-row style="margin-top: 20px;"
                 type="flex"
                 justify="space-around">
          <!-- <van-col span="6"
                   class="click_able">
            <div class="button people">成员</div>
          </van-col> -->
          <van-col span="6"
                   class="click_able"
                   @click="$emit('quit', false)">
            <div class="button quit">结束授课</div>
          </van-col>
        </van-row>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { Image, Row, Col } from "vant";
Vue.use(Image).use(Row).use(Col);
export default {
  props: {},
  data () {
    return {
      activity: [],
      resource: [],
      rowspan: 4
    };
  },
  methods: {
    initData () {
      if (document.documentElement.clientWidth <= 360) {
        this.rowspan = 24;
      } else if (document.documentElement.clientWidth <= 900) {
        this.rowspan = 12;
      } else if (document.documentElement.clientWidth <= 1160) {
        this.rowspan = 6;
      }
      this.activity = [
        {
          title: "考勤",
          icon: "/images/ico_attendance@2x.png",
          url: "/attendance"
        },
        {
          title: "测验",
          icon: "/images/ico_test@2x.png",
          url: "/quiz"
        },
        {
          title: "讨论",
          icon: "/images/ico_discussion@2x.png",
          url: "/forumList"
        }
        // {
        //   title: "随机点名",
        //   icon: "/images/ico_random@2x.png",
        //   url: "/randomcall"
        // }
        // {
        //   title: "随堂提问",
        //   icon: "/images/ico_question@2x.png",
        //   url: "/followquestion",
        // },
        // {
        //   title: "白板",
        //   icon: "/images/ico_board@2x.png",
        //   url: "/whiteboard",
        // },
      ];
      this.resource = [
        {
          title: "课堂资料",
          icon: "/images/ico_material@2x.png",
          url: "/material"
        },
        // {
        //   title: "章节资料",
        //   icon: "/images/ico_chapter@2x.png",
        //   url: "/chapter",
        // },
        {
          title: "图片",
          icon: "/images/ico_picture@2x.png",
          url: "/upload?type=1"
        },
        {
          title: "视频",
          icon: "/images/ico_video@2x.png",
          url: "/upload?type=2"
        }
      ];
    },
    navigateTo (url) {
      this.$emit("close", false);
      this.$router.push(url);
    },
    handleClsoe () {
      console.log("close more");
      this.$emit("close");
    },
    stopPrev () {
      return false;
    }
  },
  created () {
    this.initData();
  }
};
</script>

<style scoped lang="less">
.scroll_wrapper {
  overflow: hidden;
}
.scroll_content {
  overflow: auto;
  width: calc(~"100% + 20px");
}
.more_wrapper {
  position: absolute;
  width: 100vw;
  height: 100vh;
  max-height: 100vh;
  z-index: 20;
  background: rgba(8, 44, 31, 0.75);
  top: 0;
  .container {
    width: 60%;
    margin: 0 auto;
    padding: 80px 0;
    height: 100vh;
    .title {
      font-size: 36px;
      color: #fff;
      font-weight: bold;
      text-align: center;
    }
    .list {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .text {
        text-align: center;
        font-size: 32px;
        font-weight: bold;
        color: #fff;
      }
    }
    .button {
      padding: 20px 0;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 32px;
      font-weight: bold;
      border-radius: 40px;
      color: #064134;
    }
    .people {
      background: #ffd723;
    }
    .quit {
      background: #ffffff;
    }
  }
}
</style>
